// The badges in the menu. Each is a normal cached request (shared with the screen that shows the same list),
// refreshed every minute while the tab is visible, and after every write.
import { useQueries } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { useSession } from "../../lib/session";
import type { CountKey } from "./nav";

type Def = [CountKey, string, (r: never) => number];
const len = (r: unknown[]) => r.length;

export function useCounts(): Partial<Record<CountKey, number>> {
  const { me, modOn } = useSession();
  const role = me.role;
  const defs: Def[] = [];
  const add = (mod: string | null, d: Def) => { if (modOn(mod)) defs.push(d); };
  if (role !== "ops") add("outcomes", ["calls", "/api/calls?pending=true&days=7", len]);
  if (role === "manager" || role === "admin") add("quotes", ["approvals", "/api/approvals", len]);
  if (role === "ops" || role === "admin") add("quotes", ["queue", "/api/ops/queue", len]);
  add("quotes", ["matches", "/api/matches", len]);
  if (role !== "ops") add(null, ["inbox", "/api/notifications?unread=true", (r: { unread: number }) => r.unread]);
  if (role === "caller" || role === "rep") add("leads", ["dial", "/api/campaigns", (r: { items: { my_pending?: number }[] }) => r.items.reduce((a, x) => a + (x.my_pending || 0), 0)]);
  const qs = useQueries({ queries: defs.map(([, p]) => ({ queryKey: [p], queryFn: () => api(p), refetchInterval: 60_000 })) });
  // one failing count never blanks the rest
  return Object.fromEntries(defs.map(([k, , f], i) => [k, qs[i].data ? f(qs[i].data as never) : 0]));
}
